<template>
  <div>
    <van-action-sheet v-model="showDate" @close="cancelDate">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="切换账期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirmDate"
        @cancel="cancelDate"
      />
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDate: this.show,
      currentDate: new Date(),
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(2030, 11, 1)
    }
  },
  watch: {
    show: function(value) {
      this.showDate = value
    }
  },
  methods: {
    confirmDate(date) {
      this.$store.dispatch('app/setCurrentDate', this.Utils.df(date, '{y}-{m}-01'))
      const selectedDate = this.Utils.df(date, '{y}-{m}')
      this.showDate = false
      this.$emit('change', this.showDate, selectedDate)
    },
    cancelDate() {
      this.showDate = false
      this.$emit('change', this.showDate)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/change-ym.vue